import styled from "styled-components";

export const Container = styled.div`
  div.topBar {
    height: 56px;
    border-bottom: 1px solid var(--gray-border);
  }

  div.confirmation {
    padding: 39px 16px 0px;

    h1 {
      text-align: left;
      font-size: 1.25rem;
      font-weight: 900;
      margin-bottom: 48px;

      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: flex;
        justify-content: center;
        align-items: center;

        margin-right: 10px;

        i {
          font-size: 2.2rem;
          color: var(--yellow);
        }
      }
    }

    div.confirmation-information {
      width: 100%;
      padding: 16px;

      border: 1px solid var(--gray-border);
      border-radius: 4px;

      margin-bottom: 48px;

      div.confirmation-information-datetime {
        border-bottom: 1px solid var(--gray-border);

        p {
          font-size: 1.25rem;
          font-weight: 900;
          padding-bottom: 32px;
        }
      }

      div.confirmation-information-teacher {
        padding-top: 32px;

        div.confirmation-information-teacher-image {
          display: flex;
          align-items: center;

          margin-bottom: 32px;

          figure {
            width: 40px;
            height: 40px;

            margin-right: 16px;
            img {
              width: 100%;
              border-radius: 50%;
            }
          }
          p {
            font-size: 0.875rem;
            span {
              font-weight: 700;
            }
          }
        }

        button {
        }
      }
    }

    div.confirmation-alerts {
      h2 {
        font-size: 0.875rem;
        padding: 8px;
        margin-bottom: 40px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 5px;
        background-color: var(--yellow-alert);
        border: 1px solid var(--yellow-border-alert);

        text-transform: uppercase;

        span {
          i {
            display: flex;
            align-items: center;
            justify-content: center;

            font-size: 1.5rem;

            color: var(--yellow);
            margin-right: 11px;
          }
        }
      }

      ul {
        margin-bottom: 80px;
        li {
          padding: 17px;

          display: flex;
          justify-content: center;
          align-items: center;

          i {
            font-size: 1.5rem;
            color: var(--yellow);
            margin-right: 22px;
          }

          p {
            font-size: 0.875rem;
            text-align: left;
          }

          div.confirmation-alerts-texts {
            p {
              margin-bottom: 15px;
              span {
                font-weight: 900;
              }
            }

            p + p {
              margin-bottom: 0px;
            }
          }
        }

        li.confirmation-alerts-get-apps {
          display: none;

          div.confirmation-alerts-apps {
            width: 80%;
            margin: 0 auto;

            padding: 16px;

            background-color: var(--gray-bg);

            display: flex;
            justify-content: flex-start;
            align-items: center;

            div.confirmation-alerts-apps-qr {
              margin-right: 32px;
              figure {
                cursor: pointer;
              }
            }
            div.confirmation-alerts-apps-lojas {
              figure {
                cursor: pointer;
              }
            }
          }
        }

        li.confirmation-alerts-button-site {
          display: none;
        }

        li:nth-child(3) {
          padding: 0px;
        }

        li:nth-child(4) {
          border-bottom: 1px solid var(--gray-border);
        }
      }
    }
  }

  @media (min-width: 760px) {
    div.confirmation {
      padding-top: 72px;
      h1 {
        font-size: 1.5rem;
        margin-bottom: 50px;
        justify-content: flex-start;
      }

      div.confirmation-information {
        div.confirmation-information-datetime {
          p {
            padding-bottom: 16px;
          }
        }

        div.confirmation-information-teacher {
          padding-top: 16px;

          div.confirmation-information-teacher-image {
            margin-bottom: 16px;
          }
        }
      }

      div.confirmation-alerts {
        ul {
          li.confirmation-alerts-get-apps {
            display: initial;
          }

          li.confirmation-alerts-button-apps {
            display: none;
          }

          li.confirmation-alerts-button-site {
            display: initial;
          }
        }
      }
    }
  }
`;
